<template>
  <div class="commissionCreate">
    <van-form label-width="120px">
      <div class="title" v-if="pageType == 'detail'">
        {{ $t.salesManagement.viewSop }}
      </div>
      <div class="title" v-else>{{ $t.salesManagement.addSop }}</div>

      <div v-if="pageType == 'detail'">
        <van-field
          v-model="content.QuotationNumber"
          :label="$t.salesManagement.qNumber"
          label-class="number-label"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(content.QuotationNumber)"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div v-else>
        <van-field
          v-model="form.quotationNumber"
          :label="$t.salesManagement.qNumber"
          label-class="number-label"
          :placeholder="isView ? '' : $t.meta.input"
          :disabled="isView ? true : false"
          required
        >
          <template #button>
            <van-button size="small" type="info" @click="loadSOPCargoArrangement(true)">{{
              $t.meta.confirm
            }}</van-button>
          </template>
        </van-field>
      </div>

      <div v-if="isShow || pageType == 'detail'">
        <van-field
          v-model="content.SOPNumber"
          :label="$t.salesManagement.sopNumber"
          readonly
        />

        <div v-if="content.QuotationReferenceInfo">
          <van-field
            v-model="content.QuotationReferenceInfo.CompanyName"
            :label="$t.salesManagement.enterprise"
            type="textarea"
            rows="3"
            readonly
          />

          <van-field
            v-model="content.QuotationReferenceInfo.CustomerNumber"
            :label="$t.salesManagement.customerNumber"
            readonly
          />

          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.meta.businessType }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.BusinessType"
              direction="horizontal"
              disabled
            >
              <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
              <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
              <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
              <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
              <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
            </van-radio-group>
          </div>

          <div class="title">{{ $t.salesManagement.title6 }}</div>

          <van-field
            :value="
              content.QuotationReferenceInfo.DeliveryCountryName +
              ',' +
              content.QuotationReferenceInfo.DeliveryCityName
            "
            :label="$t.salesManagement.deliveryPort"
            readonly
            v-if="content.QuotationReferenceInfo.DeliveryCountryName"
          />

          <van-field
            :value="
              content.QuotationReferenceInfo.DestinationCountryName +
              ',' +
              content.QuotationReferenceInfo.DestinationCityName
            "
            :label="$t.salesManagement.destinationPort"
            readonly
            v-if="content.QuotationReferenceInfo.DestinationCountryName"
          />

          <van-field
            v-model="content.QuotationReferenceInfo.TCName"
            :label="$t.salesManagement.tradeTerms"
            readonly
          />

          <van-field
            v-model="content.QuotationReferenceInfo.ECDName"
            :label="$t.salesManagement.commission"
            readonly
          />

          <div class="title">{{ $t.salesManagement.title2 }}</div>

          <van-field
            v-model="content.QuotationReferenceInfo.GoodsName"
            :label="$t.salesManagement.goodsName"
            readonly
          />

          <van-field
            :value="
              content.QuotationReferenceInfo.NumberPackages +
              ' ' +
              (content.QuotationReferenceInfo.NumberPackagesUnitName
                ? content.QuotationReferenceInfo.NumberPackagesUnitName
                : '')
            "
            :label="$t.salesManagement.pNumber"
            readonly
          />

          <van-field
            :value="
              content.QuotationReferenceInfo.Volume +
              ' ' +
              (content.QuotationReferenceInfo.VolumeUnitName
                ? content.QuotationReferenceInfo.VolumeUnitName
                : '')
            "
            :label="$t.salesManagement.volume"
            readonly
          />

          <van-field
            :value="
              content.QuotationReferenceInfo.Weight +
              ' ' +
              (content.QuotationReferenceInfo.WeightUnitName
                ? content.QuotationReferenceInfo.WeightUnitName
                : '')
            "
            :label="$t.salesManagement.weight"
            readonly
          />

          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.brand }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.Brand"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.liquid }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.Liquid"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.powder }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.Powder"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.magnetic }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.Magnetic"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.export1 }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.AgentExport"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.export2 }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.ExportRebates"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
          <div class="commissionCreate-radio">
            <div class="radio-label">{{ $t.salesManagement.export3 }}</div>
            <van-radio-group
              v-model="content.QuotationReferenceInfo.Import"
              direction="horizontal"
              disabled
            >
              <van-radio name="1">{{ $t.meta.yes }}</van-radio>
              <van-radio name="0">{{ $t.meta.no }}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <!-- 卖价 -->
      <div class="sale-title">{{ $t.salesManagement.sellTitle }}</div>

      <div class="multi-table" v-if="form.sellPolTable">
        <van-field name="stepper" :label="$t.salesManagement.polTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.sellPolTable.length"
              @minus="handleSellDel('pol')"
              @plus="handleSellAdd('pol')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.sellPolTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleSellDelByIndex('pol', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'sellPolTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'sellPolTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.sellFreightTable">
        <van-field name="stepper" :label="$t.salesManagement.freightTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.sellFreightTable.length"
              @minus="handleSellDel('freight')"
              @plus="handleSellAdd('freight')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.sellFreightTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleSellDelByIndex('freight', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'sellFreightTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'sellFreightTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Carrier"
            :label="$t.salesManagement.carrier"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.TransitTime"
            :label="$t.salesManagement.transitTime"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.sellPodTable">
        <van-field name="stepper" :label="$t.salesManagement.podTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.sellPodTable.length"
              @minus="handleSellDel('pod')"
              @plus="handleSellAdd('pod')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.sellPodTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleSellDelByIndex('pod', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'sellPodTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'sellPodTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.sellSeriveTable">
        <van-field name="stepper" :label="$t.salesManagement.serviceTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.sellSeriveTable.length"
              @minus="handleSellDel('service')"
              @plus="handleSellAdd('service')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.sellSeriveTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleSellDelByIndex('service', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'sellSeriveTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'sellSeriveTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <!-- 成本 -->
      <div class="cost-title">{{ $t.salesManagement.costTitle }}</div>

      <div class="multi-table" v-if="form.costPolTable">
        <van-field name="stepper" :label="$t.salesManagement.polTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.costPolTable.length"
              @minus="handleCostDel('pol')"
              @plus="handleCostAdd('pol')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.costPolTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCostDelByIndex('pol', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'costPolTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'costPolTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.costFreightTable">
        <van-field name="stepper" :label="$t.salesManagement.freightTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.costFreightTable.length"
              @minus="handleCostDel('freight')"
              @plus="handleCostAdd('freight')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.costFreightTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCostDelByIndex('freight', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'costFreightTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'costFreightTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Carrier"
            :label="$t.salesManagement.carrier"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.TransitTime"
            :label="$t.salesManagement.transitTime"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.costPodTable">
        <van-field name="stepper" :label="$t.salesManagement.podTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.costPodTable.length"
              @minus="handleCostDel('pod')"
              @plus="handleCostAdd('pod')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.costPodTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCostDelByIndex('pod', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'costPodTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'costPodTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.costSeriveTable">
        <van-field name="stepper" :label="$t.salesManagement.serviceTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.costSeriveTable.length"
              @minus="handleCostDel('service')"
              @plus="handleCostAdd('service')"
              :disable-input="true"
              :disabled="isView ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.costSeriveTable" :key="index">
          <div class="multi-table-header" v-if="!isView">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCostDelByIndex('service', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'costSeriveTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'costSeriveTable')"
            :placeholder="isView ? '' : $t.meta.select"
            :disabled="isView ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="isView ? '' : $t.meta.input"
            :disabled="isView ? true : false"
          />
        </div>
      </div>

      <van-field
        v-model="form.notes"
        :label="$t.salesManagement.notes"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        type="textarea"
        rows="5"
      />

      <div style="margin: 16px" v-if="pageType == 'detail'">
        <van-button round block type="info" @click="onEdit" v-if="!isView">{{
          $t.meta.save
        }}</van-button>
      </div>
      <div style="margin: 16px" v-else>
        <van-button round block type="info" @click="onSubmit" v-if="!isView">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showItemPicker" round position="bottom">
      <van-picker
        :title="$t.meta.chagreTitle"
        show-toolbar
        :columns="billList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'BillName', 'BillId')"
        @cancel="showItemPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'CurrencySn', 'Currency')"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <div class="tool-bar" v-if="pageType == 'detail'">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "commissionCreate",
  data() {
    return {
      pageType: "new",
      isView: false,
      isShow: false,
      content: {
        QuotationReferenceInfo: null,
      },
      currencyList: [],
      billList: [],
      form: {
        orderId: "", //委托单Id
        sopId: "", //SOP货物安排Id
        quotationNumber: "", //报价单号
        sellPolTable: [],
        sellFreightTable: [],
        sellPodTable: [],
        sellSeriveTable: [],
        costPolTable: [],
        costFreightTable: [],
        costPodTable: [],
        costSeriveTable: [],
        notes: "",
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      },
      //picker
      itemIndex: 0,
      itemTable: "sellPolTable",
      showItemPicker: false,
      showCurrencyPicker: false,
    };
  },
  created() {
    const { OrderId, SOPId, isView } = this.$route.query;
    this.form.orderId = OrderId; //委托单Id
    this.form.sopId = SOPId; //SOP号
    this.isView = isView; // 仅查看
    if (this.form.sopId) {
      this.pageType = "detail";
    } else {
      this.pageType = "new";
    }
    this.getOptions().then((success) => {
      if (success) {
        this.loadSOPCargoArrangement(false);
      }
    });
  },
  methods: {
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getBillPaymentList(), this.getCurrencyList()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadSOPCargoArrangement(isShow) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        let param = {
          SOPId: this.form.sopId,
          OrderId: this.form.orderId,
          CompanyId: this.form.CompanyId,
          QuotationNumber: this.form.quotationNumber,
        };
        this.$api.salesManagement
          .loadSOPCargoArrangement(param)
          .then((res) => {
            this.content = res.data;
            if (isShow) {
              this.isShow = true;
            }
            this.form.notes = this.content.OperationNotes;
            this.applyData(this.content);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      var param = {
        OrderId: this.form.orderId,
        QCId: this.content.QCId,
        AddUserId: this.form.UserId,
        OperationNotes: this.form.notes,
        QuotationChargesItemList: this.form.sellPolTable.concat(
          this.form.sellFreightTable,
          this.form.sellPodTable,
          this.form.sellSeriveTable
        ),
        SOPCargoArrangementItemList: this.form.costPolTable.concat(
          this.form.costFreightTable,
          this.form.costPodTable,
          this.form.costSeriveTable
        ),
      };
      this.$commonMethod.showLoading();
      this.$api.salesManagement
        .addSOPCargoArrangement(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onEdit() {
      var param = {
        SOPId: this.content.SOPId,
        QCId: this.content.QCId,
        OperationNotes: this.form.notes,
        QuotationChargesItemList: this.form.sellPolTable.concat(
          this.form.sellFreightTable,
          this.form.sellPodTable,
          this.form.sellSeriveTable
        ),
        SOPCargoArrangementItemList: this.form.costPolTable.concat(
          this.form.costFreightTable,
          this.form.costPodTable,
          this.form.costSeriveTable
        ),
      };
      this.$commonMethod.showLoading();
      this.$api.salesManagement
        .editSOPCargoArrangement(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.loadSOPCargoArrangement(false).then((success) => {
            if (success) {
              this.applyData(this.content);
            }
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    applyData(data) {
      if (data.QuotationChargesItemList) {
        this.form.sellPolTable = data.QuotationChargesItemList.QuotationChargesItemList1;
        for (const sellPolItem of this.form.sellPolTable) {
          var bill = this.billList.find((c) => c.value == sellPolItem.BillId);
          if (bill) {
            sellPolItem.BillName = bill.text;
          }
          var currency = this.currencyList.find((c) => c.value == sellPolItem.Currency);
          if (currency) {
            sellPolItem.CurrencySn = currency.text;
          }
        }
        this.form.sellFreightTable =
          data.QuotationChargesItemList.QuotationChargesItemList2;
        for (const sellFreightItem of this.form.sellFreightTable) {
          var bill = this.billList.find((c) => c.value == sellFreightItem.BillId);
          if (bill) {
            sellFreightItem.BillName = bill.text;
          }
          var currency = this.currencyList.find(
            (c) => c.value == sellFreightItem.Currency
          );
          if (currency) {
            sellFreightItem.CurrencySn = currency.text;
          }
        }
        this.form.sellPodTable = data.QuotationChargesItemList.QuotationChargesItemList3;
        for (const sellPodItem of this.form.sellPodTable) {
          var bill = this.billList.find((c) => c.value == sellPodItem.BillId);
          if (bill) {
            sellPodItem.BillName = bill.text;
          }
          var currency = this.currencyList.find((c) => c.value == sellPodItem.Currency);
          if (currency) {
            sellPodItem.CurrencySn = currency.text;
          }
        }
        this.form.sellSeriveTable =
          data.QuotationChargesItemList.QuotationChargesItemList4;
        for (const sellSeriveItem of this.form.sellSeriveTable) {
          var bill = this.billList.find((c) => c.value == sellSeriveItem.BillId);
          if (bill) {
            sellSeriveItem.BillName = bill.text;
          }
          var currency = this.currencyList.find(
            (c) => c.value == sellSeriveItem.Currency
          );
          if (currency) {
            sellSeriveItem.CurrencySn = currency.text;
          }
        }
      }
      if (data.SOPCargoArrangementItemList) {
        this.form.costPolTable =
          data.SOPCargoArrangementItemList.SOPCargoArrangementItemList1;
        for (const costPolItem of this.form.costPolTable) {
          var bill = this.billList.find((c) => c.value == costPolItem.BillId);
          if (bill) {
            costPolItem.BillName = bill.text;
          }
          var currency = this.currencyList.find((c) => c.value == costPolItem.Currency);
          if (currency) {
            costPolItem.CurrencySn = currency.text;
          }
        }
        this.form.costFreightTable =
          data.SOPCargoArrangementItemList.SOPCargoArrangementItemList2;
        for (const costFreightItem of this.form.costFreightTable) {
          var bill = this.billList.find((c) => c.value == costFreightItem.BillId);
          if (bill) {
            costFreightItem.BillName = bill.text;
          }
          var currency = this.currencyList.find(
            (c) => c.value == costFreightItem.Currency
          );
          if (currency) {
            costFreightItem.CurrencySn = currency.text;
          }
        }
        this.form.costPodTable =
          data.SOPCargoArrangementItemList.SOPCargoArrangementItemList3;
        for (const costPodItem of this.form.costPodTable) {
          var bill = this.billList.find((c) => c.value == costPodItem.BillId);
          if (bill) {
            costPodItem.BillName = bill.text;
          }
          var currency = this.currencyList.find((c) => c.value == costPodItem.Currency);
          if (currency) {
            costPodItem.CurrencySn = currency.text;
          }
        }
        this.form.costSeriveTable =
          data.SOPCargoArrangementItemList.SOPCargoArrangementItemList4;
        for (const costSeriveItem of this.form.costSeriveTable) {
          var bill = this.billList.find((c) => c.value == costSeriveItem.BillId);
          if (bill) {
            costSeriveItem.BillName = bill.text;
          }
          var currency = this.currencyList.find(
            (c) => c.value == costSeriveItem.Currency
          );
          if (currency) {
            costSeriveItem.CurrencySn = currency.text;
          }
        }
      }
      this.$commonMethod.fieldRefresh(".commissionCreate");
    },
    pickerShow(index, pickerName, table) {
      if (this.isView) {
        return;
      }
      this[pickerName] = true;
      this.itemIndex = index;
      if (table) this.itemTable = table;
    },
    pickerConfirm(e, text, value) {
      this.form[this.itemTable][this.itemIndex][text] = e.text;
      this.form[this.itemTable][this.itemIndex][value] = e.value;
      this.showItemPicker = false;
      this.showCurrencyPicker = false;
    },
    //卖价
    handleSellAdd(type) {
      if (type == "pol") {
        this.form.sellPolTable.push({
          ChargeType: 1,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "freight") {
        this.form.sellFreightTable.push({
          ChargeType: 2,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
          Carrier: "", //航空公司
          TransitTime: "", //运输时长
        });
      }
      if (type == "pod") {
        this.form.sellPodTable.push({
          ChargeType: 3,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "service") {
        this.form.sellSeriveTable.push({
          ChargeType: 4,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
    },
    handleSellDel(type) {
      if (type == "pol" && this.form.sellPolTable.length > 0) {
        this.form.sellPolTable.pop();
      }
      if (type == "freight" && this.form.sellFreightTable.length > 0) {
        this.form.sellFreightTable.pop();
      }
      if (type == "pod" && this.form.sellPodTable.length > 0) {
        this.form.sellPodTable.pop();
      }
      if (type == "service" && this.form.sellSeriveTable.length > 0) {
        this.form.sellSeriveTable.pop();
      }
    },
    handleSellDelByIndex(type, index) {
      if (type == "pol" && this.form.sellPolTable.length > 0) {
        this.form.sellPolTable.splice(index, 1);
      }
      if (type == "freight" && this.form.sellFreightTable.length > 0) {
        this.form.sellFreightTable.splice(index, 1);
      }
      if (type == "pod" && this.form.sellPodTable.length > 0) {
        this.form.sellPodTable.splice(index, 1);
      }
      if (type == "service" && this.form.sellSeriveTable.length > 0) {
        this.form.sellSeriveTable.splice(index, 1);
      }
    },
    //成本
    handleCostAdd(type) {
      if (type == "pol") {
        this.form.costPolTable.push({
          ChargeType: 1,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "freight") {
        this.form.costFreightTable.push({
          ChargeType: 2,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
          Carrier: "", //航空公司
          TransitTime: "", //运输时长
        });
      }
      if (type == "pod") {
        this.form.costPodTable.push({
          ChargeType: 3,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "service") {
        this.form.costSeriveTable.push({
          ChargeType: 4,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
    },
    handleCostDel(type) {
      if (type == "pol" && this.form.costPolTable.length > 0) {
        this.form.costPolTable.pop();
      }
      if (type == "freight" && this.form.costFreightTable.length > 0) {
        this.form.costFreightTable.pop();
      }
      if (type == "pod" && this.form.costPodTable.length > 0) {
        this.form.costPodTable.pop();
      }
      if (type == "service" && this.form.costSeriveTable.length > 0) {
        this.form.costSeriveTable.pop();
      }
    },
    handleCostDelByIndex(type, index) {
      if (type == "pol" && this.form.costPolTable.length > 0) {
        this.form.costPolTable.splice(index, 1);
      }
      if (type == "freight" && this.form.costFreightTable.length > 0) {
        this.form.costFreightTable.splice(index, 1);
      }
      if (type == "pod" && this.form.costPodTable.length > 0) {
        this.form.costPodTable.splice(index, 1);
      }
      if (type == "service" && this.form.costSeriveTable.length > 0) {
        this.form.costSeriveTable.splice(index, 1);
      }
    },
    gotoPrint() {
      var param = {
        SOPId: this.form.sopId,
        OrderId: this.form.orderId,
        CompanyId: this.form.CompanyId,
        QuotationNumber: this.form.quotationNumber,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createSOPCargoArrangementFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.commissionCreate {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }

  .cost-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e4f6f0;
    color: #20b2aa;
    border: 2px solid #20b2aa;
  }

  .sale-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e8f4ff;
    color: #1e90ff;
    border: 2px solid #87ceeb;
  }

  .commissionCreate-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .commissionCreate-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
